/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { ResultsPartialSummitRegistrantObjectId } from '../models/ResultsPartialSummitRegistrantObjectId';
import { SummitRegistrant } from '../models/SummitRegistrant';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class SummitRegistrantApiResource {

    /**
     * Create a summitRegistrant
     * 
     * @param body SummitRegistrant data to create
     */
    public createSummitRegistrant(body?: Partial<SummitRegistrant>, axiosConfig?: AxiosRequestConfig): Promise<SummitRegistrant> {
        const reqPath = '/v1/summitregistrant';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Delete an existing summitRegistrant
     * 
     * @param id SummitRegistrant id
     */
    public deleteSummitRegistrant(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/summitregistrant/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'DELETE',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return summitRegistrants, or query by type or search string
     * 
     * @param type summitRegistrant type to filter by
     * @param q query search string
     * @param from SummitRegistrant id to start from
     * @param limit Number of results to return
     */
    public findSummitRegistrants(query?: { type?: string, q?: string, from?: string, limit?: number }, axiosConfig?: AxiosRequestConfig): Promise<ResultsPartialSummitRegistrantObjectId> {
        const reqPath = '/v1/summitregistrant';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular summitRegistrant by id
     * 
     * @param id SummitRegistrant id
     */
    public getSummitRegistrant(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<SummitRegistrant> {
        const reqPath = '/v1/summitregistrant/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular summitRegistrant by slug
     * 
     * @param slug Slug
     */
    public getSummitRegistrantBySlug(slug: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<SummitRegistrant> {
        const reqPath = '/v1/summitregistrant/slug/{slug}'
                    .replace('{' + 'slug}', String(slug));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Update an existing summitRegistrant
     * 
     * @param id SummitRegistrant id
     * @param body SummitRegistrant data to update
     */
    public updateSummitRegistrant(id: Partial<string>, body?: Partial<SummitRegistrant>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/summitregistrant/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'PATCH',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const SummitRegistrantApi = new SummitRegistrantApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/SummitRegistrantApi.ts